module.exports = {
          srcSet: __webpack_public_path__ + "img/b2e2960-960.jpg"+" 960w",
          images:[ {path: __webpack_public_path__ + "img/b2e2960-960.jpg",width: 960,height: 960}],
          src: __webpack_public_path__ + "img/b2e2960-960.jpg",
          toString:function(){return __webpack_public_path__ + "img/b2e2960-960.jpg"},
          
          width: 960,
          height: 960
        }